<h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ 'referalsInfoWindow.txtTitle' | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content #myContainer>
    <div class="d-flex flex-column pt-3" style="gap: 0.875rem;">
        <div class="d-flex flex-column gap-3 info">
            <span>{{ 'referalsInfoWindow.txtInternalLink' | translate }}</span>
            <div>
                <span class="form-input" id="internalLink">
                    <span>
                        {{ configuration.configuration.profile.int.url }}
                    </span>
                </span>
                <button class="btn-copy-link" matSuffix aria-label="Clear" (click)="eventCopyLink(configuration.configuration.profile.int.url, 'internalLink')" matTooltip="{{ 'shared.txtDialogBtn' | translate }}">
                    <mat-icon aria-hidden="false" fontIcon="content_copy"></mat-icon>
                </button>
            </div>
        </div>
        @if(configuration.configuration.profile.ext?.company){
            <div class="d-flex flex-column gap-3">
                <span class="company">{{ 'referalsInfoWindow.txtCompanyName' | translate }}</span>
                <span class="company-name">{{ configuration.configuration.profile.ext?.company }}</span>
            </div>
        } @else {
            <div class="d-flex justify-content-center align-items-center" style="text-align: center;margin-top: 10px;">
                <span class="not-company">
                   {{ 'referalsInfoWindow.txtNotEnoughInfo' | translate }} 
                </span>
            </div>
        }
    </div>
    @if(configuration.configuration.profile.ext){
        <div class="line"></div>
        <div class="d-flex flex-column" style="gap: 0.875rem;">
            @if(configuration.configuration.profile.ext?.urls){
                <div class="d-flex flex-column gap-3 info">
                    <span>{{ 'referalsInfoWindow.txtEUMarket' | translate }}</span>
                    
                        @if(configuration.configuration.config.show_ext_links){
                            <div>
                            <span class="form-input" id="marketEU">
                                <span>
                                    {{ configuration.configuration.profile.ext?.urls.market_eu }}
                                </span>
                            </span>
                            <button class="btn-copy-link" matSuffix aria-label="Clear" (click)="eventCopyLink(configuration.configuration.profile.ext?.urls.market_eu, 'marketEU')" matTooltip="{{ 'shared.txtDialogBtn' | translate }}">
                                <mat-icon aria-hidden="false" fontIcon="content_copy"></mat-icon>
                            </button>
                            </div>
                        }@else{
                            <div style="text-align: center;">
                                <span style="color: #777777 !important;position: absolute;z-index: 9;top: 50%;transform: translate(-50%, -50%); width: 100%;">
                                    {{ 'referalsInfoWindow.txtNotEnoughFunds' | translate }}
                                </span>
                                <span class="form-input justify-content-center" style="filter: blur(4px);">                        
                                </span>
                            </div>
                        }
                        
                    
                </div>
                <div class="d-flex flex-column gap-3 info">
                    <span>{{ 'referalsInfoWindow.txtMarket25' | translate }}</span>
                    
                         @if(configuration.configuration.config.show_ext_links){
                            <div>
                            <span class="form-input" id="market25">
                                <span>
                                    {{ configuration.configuration.profile.ext?.urls.market_25 }}
                                </span>
                            </span>
                            <button class="btn-copy-link" matSuffix aria-label="Clear" (click)="eventCopyLink(configuration.configuration.profile.ext?.urls.market_25, 'market25')" matTooltip="{{ 'shared.txtDialogBtn' | translate }}">
                                <mat-icon aria-hidden="false" fontIcon="content_copy"></mat-icon>
                            </button>
                            </div>
                        }@else{
                            <div style="text-align: center;">
                                <span style="color: #777777 !important;position: absolute;z-index: 9;top: 50%;transform: translate(-50%, -50%); width: 100%;">
                                    {{ 'referalsInfoWindow.txtNotEnoughFunds' | translate }}
                                </span>
                                <span class="form-input justify-content-center" style="filter: blur(4px);">                        
                                </span>
                            </div>
                        }
                    
                </div>
            }
            @if( configuration.configuration.profile.ext?.url ){
                <div class="d-flex flex-column gap-3 info">
                    <span>{{ 'referalsInfoWindow.txtExternalLink' | translate }}</span>
                    
                        @if(configuration.configuration.config.show_ext_links){
                            <div>
                            <span class="form-input" id="externalLink">
                                <span>
                                    {{ configuration.configuration.profile.ext?.url }}
                                </span>
                            </span>
                            <button class="btn-copy-link" matSuffix aria-label="Clear" (click)="eventCopyLink(configuration.configuration.profile.ext?.url, 'externalLink')" matTooltip="{{ 'shared.txtDialogBtn' | translate }}">
                                <mat-icon aria-hidden="false" fontIcon="content_copy"></mat-icon>
                            </button>
                            </div>
                        }@else{
                            <div style="text-align: center;">
                                <span style="color: #777777 !important;position: absolute;z-index: 9;top: 50%;transform: translate(-50%, -50%); width: 100%;">
                                    {{ 'referalsInfoWindow.txtNotEnoughFunds' | translate }}
                                </span>
                                <span class="form-input justify-content-center" style="filter: blur(4px);">                        
                                </span>
                            </div>
                        }
                    
                </div>
            }
            
            
        </div>     
    }
    
 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups w-100"> 
        @if(!configuration.configuration.profile.ext?.company){
            <div class="for_btn-group d-flex align-items-center w-100">
                <button class="btn-accept w-100" (click)="linksCabinet()">
                    <span>{{ 'buttons.txtDashboard' | translate }}</span>
                </button>
                <button class="btn-cancel w-100" (click)="onNoClick()">
                    <span>{{ 'buttons.txtClose' | translate }}</span>
                </button>
            </div>
            
        } @else {
            <button class="btn-accept" (click)="onNoClick()">
                <span>{{ 'buttons.txtClose' | translate }}</span>
            </button>
        }
     </div>       
   </mat-dialog-actions>